import Vue from 'vue';
import zhMap from './lang/zh.js';
import enMap from './lang/en.js';

Vue.use(VueI18n);

// Vuei18n增加方法，匹配不到code返回undefined
Vue.prototype.$tec = function (code) {
  if (!code) return undefined;
  const errorKey = `errorMap[${code}]`;
  return this.$te(errorKey) ? this.$t(errorKey) : undefined;
};

const messageMap = {
  zh: zhMap,
  en: enMap
};

const localUserLang = localStorage.getItem('user-lang');
const currentLang = ['zh', 'en'].includes(localUserLang) ? localUserLang : 'zh';
const i18n = new VueI18n({
  // 默认语言，优先从本地存储读取
  locale: currentLang,
  messages: messageMap,
  silentTranslationWarn: true // 可选：屏蔽翻译警告
});

export const loadLocale = function (lang) {
  i18n.locale = lang; // 切换语言
  localStorage.setItem('user-lang', lang); // 持久化存储

  // vhall-ui组件国际化支持
  // eslint-disable-next-line no-undef
  VHALLUI.locale({ el: messageMap[lang].el });

  const bodyEle = document.querySelector('body');
  if (bodyEle) {
    bodyEle.classList.add(`is-${lang}`);
  }
};

loadLocale(currentLang);

window.i18n_ai = i18n;
export default i18n;
